import {
  createBrowserRouter,
  createRoutesFromElements,
  Outlet,
  Route,
  RouterProvider,
  ScrollRestoration,
} from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import Header from "./components/header/Header";
import Home from "./pages/Home";
import Cart from "./pages/Cart";
import Signin from "./pages/Signin";
import Registration from "./pages/Registration";
// import Dashboard from "./pages/dashboard/DashBoard";
import Success from "./pages/success/Success";
import Cancel from "./pages/Cancel/Cancel";
import Tabla from "./pages/Categories/Tabla";
import Traditional from "./pages/Categories/Traditional";
import Drums from "./pages/Categories/Drums";
import Keys from "./pages/Categories/Keys";
import Tutorials from "./pages/Categories/Tutorials";
import Strings from "./pages/Categories/Strings";
import Footer3 from "./components/footer/Footer3";
// import CoursesPage from "./pages/CoursesPage";
import NearbyClasses from "./components/nearbyClasses/NearbyClasses";
import ProductD from "./components/home/ProductD";
import OnlineTutor from "./components/OnlineTutor/OnlineTutor";
import RoomPage from "./components/OnlineTutor/Room";
import Udemy from "./components/courses/Udemy";
import Spotify from "./components/spotify/Spotify";
// import ProductsDashboard from "./pages/dashboard/ProductsDashboard";
import DashHeader from "./pages/dashboard/DashHeader";
// import Footer2 from "./components/footer/Footer2";

const Layout = () => {
  return (
    <div>
      <Header />
      {/* <Test /> */}
      {/* for scrolling the page to top after we return to the page */}
      <ScrollRestoration />
      <Outlet />
      <Footer3 />
      {/* <Footer2 /> */}
    </div>
  );
};
function App() {
  const client = new QueryClient({
    defaultOptions: {
      queries: {
        refetchOnWindowFocus: false,
        // staleTime: 600000,
      },
    },
  });

  const router = createBrowserRouter(
    createRoutesFromElements(
      <Route>
        <Route path="/" element={<Layout />}>
          <Route index element={<Home />}></Route>
          <Route path="/cart" element={<Cart />}></Route>
          <Route path="/categories/Percussion" element={<Tabla />}></Route>
          <Route path="/categories/Wind" element={<Traditional />}></Route>
          <Route path="/categories/Traditional" element={<Drums />}></Route>
          <Route path="/categories/Strings" element={<Strings />}></Route>
          <Route path="/categories/Keyboard" element={<Keys />}></Route>
          <Route path="/categories/Tutorials" element={<Tutorials />}></Route>
          <Route path="/categories/courses" element={<Udemy />}></Route>
          <Route path="/categories/music" element={<Spotify />}></Route>
          <Route
            path="/categories/OnlineTutor"
            element={<OnlineTutor />}
          ></Route>
          <Route path="/productDetails/:id" element={<ProductD />}></Route>
          {/* <Route path="/udemy" element={<Udemy />}></Route> */}

          <Route
            path="/categories/MusicClasses"
            element={<NearbyClasses />}
          ></Route>
        </Route>
        <Route path="/signin" element={<Signin />}></Route>
        <Route path="/registration" element={<Registration />}></Route>
        <Route path="/success" element={<Success />}></Route>
        <Route path="/cancel" element={<Cancel />}></Route>
        {/* <Route path="/admin" element={<Dashboard />}></Route> */}
        <Route path="/admin" element={<DashHeader />}></Route>
        {/* <Route path="/adminDashboard" element={<ProductsDashboard />}></Route> */}
        {/* <Route path="/videoCall/:tutorName" element={<RoomPage />}></Route> */}
        <Route path="/videoCall/:roomId" element={<RoomPage />}></Route>
      </Route>
    )
  );
  return (
    <div className="font-bodyFont bg-gray-100">
      <QueryClientProvider client={client}>
        <RouterProvider router={router}></RouterProvider>
      </QueryClientProvider>
    </div>
  );
}

export default App;

// export const BaseURL = "http://localhost:3001";
export const BaseURL = "https://snk-music-store-backend.onrender.com";
// export const BaseURL = "https://snk-music-store-backend.cyclic.app";
